import { useMemo } from "react";
import { useQuery, useQueryClient } from "react-query";
import { JobHttpService } from "../service";

const sanitizeFilters = (filters = {}) => {
    return Object.entries(filters)
        .filter(([, value]) => value !== undefined && value !== null && value !== "")
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
};

function UseJobList({ page = 1, size = 30, filters = {} }) {
    const queryClient = useQueryClient();
    const cleanedFilters = useMemo(() => sanitizeFilters(filters), [filters]);
    const queryKey = ["job_list", page, size, cleanedFilters];

    const { data, isLoading, isError, refetch, isFetching } = useQuery(
        queryKey,
        () => JobHttpService.loadJobs({ page, size, filters: cleanedFilters }),
        {
            keepPreviousData: true
        }
    );

    const removeItemFromList = (jobId) => {
        queryClient.setQueryData(queryKey, (oldData) => {
            if (!oldData || !oldData.results) return oldData;
            return {
                ...oldData,
                results: oldData.results.filter((job) => job.id !== jobId)
            };
        });
    };

    return { data, isLoading, isFetching, isError, refetch, removeItemFromList };
}

export default UseJobList;
